(() => {
  if (window.__MM_CARD_PARITY_LOADED__) return;
  window.__MM_CARD_PARITY_LOADED__ = true;

  const markerSelector = '[data-mm-product-compliance][data-mm-context="card"]';
  const ptBrLocale = () => {
    const locale = (document.documentElement.lang || '').toLowerCase();
    return locale === 'pt-br' || locale === 'pt_br' || locale.startsWith('pt-br');
  };

  const ptBrExact = new Map([
    ['Sign in or create account', 'Entrar ou criar uma conta'],
    ['Continue with Google', 'Continuar com o Google'],
    ['Continue with Facebook', 'Continuar com o Facebook'],
    ['Continue with Apple', 'Continuar com a Apple'],
    ['OR', 'OU'],
    ['Sign in', 'Entrar'],
    ['Log in', 'Entrar'],
    ['Login', 'Entrar'],
    ['Create account', 'Criar conta'],
    ['Create an account', 'Criar conta'],
    ['Sign out', 'Sair'],
    ['Log out', 'Sair'],
    ['My account', 'Minha conta'],
    ['Account', 'Conta'],
    ['Close menu', 'Fechar menu'],
    ['Quick links', 'Acessos rápidos'],
    ['Email', 'E-mail'],
    ['Email address', 'Endereço de e-mail'],
    ['Password', 'Senha'],
    ['Forgot password?', 'Esqueceu sua senha?'],
    ['Continue', 'Continuar'],
    ['Search', 'Pesquisar'],
    ['Search...', 'Pesquisar...'],
    ['Cart', 'Carrinho'],
    ['Your cart', 'Seu carrinho'],
    ['View cart', 'Ver carrinho'],
    ['Checkout', 'Finalizar compra'],
    ['Continue shopping', 'Continuar comprando'],
    ['Add to cart', 'Adicionar ao carrinho'],
    ['Sold out', 'Esgotado'],
    ['Unavailable', 'Indisponível'],
    ['Quick view', 'Visualização rápida'],
    ['View details', 'Ver detalhes'],
    ['View all', 'Ver tudo'],
    ['Shop now', 'Comprar agora'],
    ['Buy now', 'Comprar agora'],
    ['Contact us', 'Fale conosco'],
    ['Contact information', 'Informações de contato'],
    ['Button label', 'Texto do botão'],
    ['Subscribe', 'Assinar'],
    ['Your email', 'Seu e-mail'],
    ['Apply', 'Aplicar'],
    ['Cancel', 'Cancelar'],
    ['Save', 'Salvar'],
    ['Close', 'Fechar'],
    ['Back', 'Voltar'],
    ['Next', 'Próximo'],
    ['Previous', 'Anterior'],
    ['Loading', 'Carregando'],
    ['Show more', 'Mostrar mais'],
    ['Show less', 'Mostrar menos'],
    ['Read more', 'Leia mais'],
    ['Filter', 'Filtrar'],
    ['Filter and sort', 'Filtrar e ordenar'],
    ['Apply filters', 'Aplicar filtros'],
    ['Sort by', 'Ordenar por'],
    ['Clear all', 'Limpar tudo'],
    ['Reset', 'Redefinir'],
    ['Remove', 'Remover'],
    ['Availability', 'Disponibilidade'],
    ['Price', 'Preço'],
    ['Products', 'Produtos'],
    ['Collections', 'Coleções'],
    ['Pages', 'Páginas'],
    ['Articles', 'Artigos'],
    ['Results', 'Resultados'],
    ['No results', 'Nenhum resultado'],
    ['Pickup available', 'Retirada disponível'],
    ['Pickup unavailable', 'Retirada indisponível'],
    ['Compare', 'Comparar'],
    ['Quantity', 'Quantidade'],
    ['Subtotal', 'Subtotal'],
    ['Total', 'Total'],
    ['Discount', 'Desconto'],
    ['Shipping', 'Frete'],
    ['Free shipping', 'Frete grátis'],
    ['In stock', 'Em estoque'],
    ['Out of stock', 'Sem estoque'],
    ['Menu', 'Menu'],
    ['Popup Minimal', 'Janela minimalista'],
    ['Sidebar title', 'Título da barra lateral'],
    ['Shop the products in this post', 'Compre os produtos deste artigo'],
    ['Promotion banner', 'Banner promocional'],
    ['Describe a promotion, make announcements about the promotion available in your store.', 'Descreva uma promoção ou anuncie uma oferta disponível na loja.'],
    ['Add further details to enrich your blog post page', 'Adicione mais detalhes para enriquecer a página do artigo'],
    ['Table of Contents', 'Índice'],
    ['Blog tags', 'Tags do blog'],
    ['Coming Soon', 'Em breve'],
    ['Be the first to know when we launch.', 'Seja o primeiro a saber quando lançarmos a loja.'],
    ["You'll love this too", 'Você também pode precisar...'],
    ['The best 🤝', 'O melhor 🤝'],
    ['Botão alternar mobile', 'Botão do menu no celular'],
    ['Faça login aqui', 'Entre aqui'],
    ['Faça login', 'Entre'],
    ['Fazer login', 'Entrar'],
    ['Fornecedor do produto', 'Marca do produto'],
    ['Texto esqueleto', 'Texto de carregamento'],
    ['Adicionar ao pacote', 'Adicionar ao kit'],
    ['Ver meu pacote', 'Ver meu kit'],
    ['Ver / Editar meu pacote', 'Ver / Editar meu kit'],
    ['Nome do pacote', 'Nome do kit'],
    ['Link da imagem', 'Endereço da imagem'],
    ['Link do banner', 'Endereço do banner'],
    ['Ir para o slide', 'Ir para o item do carrossel'],
    ['Iniciar sessão', 'Entrar'],
    ['Terminar sessão', 'Sair'],
    ['Palavra-passe', 'Senha'],
    ['Correio eletrónico', 'E-mail'],
    ['Cesto', 'Carrinho'],
    ['Encomenda', 'Pedido'],
    ['Encomendas', 'Pedidos'],
    ['Morada', 'Endereço'],
    ['Telemóvel', 'Celular'],
    ['Ficheiro', 'Arquivo'],
    ['Ficheiros', 'Arquivos'],
    ['Utilizador', 'Usuário'],
    ['Utilizadores', 'Usuários'],
    ['Registar', 'Criar conta'],
    ['Registo', 'Cadastro'],
    ['Subscrição', 'Assinatura'],
    ['Subscrever', 'Assinar'],
    ['Stock', 'Estoque'],
    ['Em stock', 'Em estoque'],
    ['Sem stock', 'Sem estoque'],
    ['Portes', 'Frete'],
    ['Powered by Shopify', 'Tecnologia Shopify'],
    ['Click to open Judge.me floating reviews tab', 'Abrir avaliações de clientes'],
    ['Sort reviews by', 'Ordenar avaliações por'],
    ['image-thumbnail', 'Miniatura do produto'],
    ['Criar seu cadastro de empresa para comprar onine', 'Criar seu cadastro de empresa para comprar online']
  ]);

  const translatePtBrValue = (value) => {
    if (!ptBrLocale() || typeof value !== 'string' || value.length === 0) return value;

    const leading = value.match(/^\s*/)?.[0] || '';
    const trailing = value.match(/\s*$/)?.[0] || '';
    const core = value.trim();
    if (!core) return value;

    let translated = ptBrExact.get(core) || core;
    translated = translated.replace(/\bno checkout\b/gi, 'na finalização da compra');
    translated = translated.replace(/\bdo checkout\b/gi, 'da finalização da compra');
    translated = translated.replace(/\bao checkout\b/gi, 'à finalização da compra');
    translated = translated.replace(/\bcheckout\b/gi, 'finalização da compra');
    translated = translated.replace(/(\d+(?:[.,]\d+)?)\s*%\s*OFF\b/gi, '$1% de desconto');
    translated = translated.replace(/\bIn stock\b/gi, 'Em estoque');
    translated = translated.replace(/\bOut of stock\b/gi, 'Sem estoque');
    translated = translated.replace(/\bPalavra-passe\b/gi, 'Senha');
    translated = translated.replace(/\bCorreio eletrónico\b/gi, 'E-mail');
    translated = translated.replace(/\bEncomendas\b/gi, 'Pedidos');
    translated = translated.replace(/\bEncomenda\b/gi, 'Pedido');
    translated = translated.replace(/\bMorada\b/gi, 'Endereço');
    translated = translated.replace(/\bTelemóvel\b/gi, 'Celular');
    translated = translated.replace(/\bFicheiros\b/gi, 'Arquivos');
    translated = translated.replace(/\bFicheiro\b/gi, 'Arquivo');
    translated = translated.replace(/\bUtilizadores\b/gi, 'Usuários');
    translated = translated.replace(/\bUtilizador\b/gi, 'Usuário');
    translated = translated.replace(/\bSubscrição\b/gi, 'Assinatura');
    translated = translated.replace(/\bSubscrever\b/gi, 'Assinar');
    translated = translated.replace(/\bEm stock\b/gi, 'Em estoque');
    translated = translated.replace(/\bSem stock\b/gi, 'Sem estoque');
    translated = translated.replace(/\bPortes\b/gi, 'Frete');

    if (translated === core) return value;
    return `${leading}${translated}${trailing}`;
  };

  const translateElementAttributes = (element) => {
    if (!element || !element.getAttribute) return;

    ['placeholder', 'aria-label', 'title'].forEach((attribute) => {
      const current = element.getAttribute(attribute);
      if (!current) return;
      const translated = translatePtBrValue(current);
      if (translated !== current) element.setAttribute(attribute, translated);
    });

    if (element.tagName === 'INPUT') {
      const type = (element.getAttribute('type') || '').toLowerCase();
      if (['submit', 'button', 'reset'].includes(type)) {
        const current = element.value;
        const translated = translatePtBrValue(current);
        if (translated !== current) element.value = translated;
      }
    }
  };

  const translateTextNode = (node) => {
    if (!node || node.nodeType !== Node.TEXT_NODE || !node.parentElement) return;
    if (['SCRIPT', 'STYLE', 'NOSCRIPT', 'CODE', 'PRE', 'TEXTAREA'].includes(node.parentElement.tagName)) return;

    const translated = translatePtBrValue(node.nodeValue);
    if (translated !== node.nodeValue) node.nodeValue = translated;
  };

  const observedRoots = new WeakSet();

  const scanTranslations = (root) => {
    if (!ptBrLocale() || !root) return;

    if (root.nodeType === Node.TEXT_NODE) {
      translateTextNode(root);
      return;
    }

    if (root.nodeType === Node.ELEMENT_NODE) translateElementAttributes(root);

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT);
    let node = walker.nextNode();
    while (node) {
      if (node.nodeType === Node.TEXT_NODE) {
        translateTextNode(node);
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        translateElementAttributes(node);
        if (node.shadowRoot) observeTranslationRoot(node.shadowRoot);
      }
      node = walker.nextNode();
    }
  };

  const observeTranslationRoot = (root) => {
    if (!ptBrLocale() || !root || observedRoots.has(root)) return;
    observedRoots.add(root);
    scanTranslations(root);

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'characterData') translateTextNode(mutation.target);
        mutation.addedNodes.forEach((node) => scanTranslations(node));
      }
    });
    observer.observe(root, { childList: true, subtree: true, characterData: true });
  };

  const findCardRoot = (marker) => {
    const direct = marker.closest('.product-card__wrapper, .product-card, [data-product-card], li');
    if (direct && direct.querySelector('.product-card__title')) return direct;

    let node = marker.parentElement;
    while (node && node !== document.body) {
      if (node.querySelector && node.querySelector('.product-card__title')) return node;
      node = node.parentElement;
    }
    return null;
  };

  const injectCa = (marker) => {
    if (!marker || marker.dataset.mmProcessed === 'true') return;

    const caSource = marker.querySelector('.mm-product-compliance__value');
    const caText = caSource ? caSource.textContent.trim() : '';
    if (!caText) {
      marker.remove();
      return;
    }

    const card = findCardRoot(marker);
    if (!card) return;

    const title = card.querySelector('.product-card__title');
    if (!title || !title.parentNode) return;

    let vendor = card.querySelector('.product-card__vendor');
    if (!vendor) {
      vendor = document.createElement('div');
      vendor.className = 'product-card__vendor product-info__vendor mm-product-card__vendor-with-ca mb-1 text-small color-text-[rgba(var(--color-text),0.6)]';
      title.parentNode.insertBefore(vendor, title);
    } else {
      vendor.classList.add('mm-product-card__vendor-with-ca');
    }

    const productId = marker.dataset.mmProductId || '';
    const escapedId = window.CSS && CSS.escape ? CSS.escape(productId) : productId.replace(/[^a-zA-Z0-9_-]/g, '');
    if (escapedId && vendor.querySelector(`[data-mm-ca-product="${escapedId}"]`)) {
      marker.remove();
      return;
    }

    const hasVendorContent = vendor.textContent.trim().length > 0;
    if (hasVendorContent && !vendor.querySelector('.mm-product-card__ca-separator')) {
      const separator = document.createElement('span');
      separator.className = 'mm-product-card__ca-separator';
      separator.setAttribute('aria-hidden', 'true');
      vendor.appendChild(separator);
    }

    const ca = document.createElement('span');
    ca.className = 'mm-product-card__ca-text';
    ca.textContent = caText;
    ca.title = 'Certificado de Aprovação';
    if (productId) ca.dataset.mmCaProduct = productId;
    vendor.appendChild(ca);

    marker.dataset.mmProcessed = 'true';
    marker.remove();
  };

  const scanCards = (root = document) => {
    if (!root) return;
    if (root.matches && root.matches(markerSelector)) injectCa(root);
    if (root.querySelectorAll) root.querySelectorAll(markerSelector).forEach(injectCa);
  };

  const getSignedOutAccountComponent = (event) => {
    const path = typeof event.composedPath === 'function' ? event.composedPath() : [];
    const accountComponent = path.find((node) => node && node.tagName === 'SHOPIFY-ACCOUNT');
    if (!accountComponent) return null;

    const signedOutAvatar = path.some((node) => {
      if (!node || !node.classList) return false;
      return node.classList.contains('header-account-icon') || node.classList.contains('mobile-header-account-icon');
    });

    return signedOutAvatar ? accountComponent : null;
  };

  const handleSignedOutAccountClick = (event) => {
    if (!ptBrLocale()) return;

    const accountComponent = getSignedOutAccountComponent(event);
    if (!accountComponent) return;

    if (accountComponent.shadowRoot) {
      observeTranslationRoot(accountComponent.shadowRoot);
      window.setTimeout(() => scanTranslations(accountComponent.shadowRoot), 0);
      window.setTimeout(() => scanTranslations(accountComponent.shadowRoot), 100);
      return;
    }

    const loginUrl = window.Maximize?.loginToViewPrice?.loginUrl;
    if (!loginUrl) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(loginUrl);
  };

  const start = () => {
    scanCards(document);
    observeTranslationRoot(document.documentElement);

    // The account component attaches its shadow DOM after the first document scan.
    customElements.whenDefined('shopify-account').then(() => {
      requestAnimationFrame(() => {
        document.querySelectorAll('shopify-account').forEach((element) => {
          if (element.shadowRoot) observeTranslationRoot(element.shadowRoot);
        });
      });
    });

    document.addEventListener('click', handleSignedOutAccountClick, true);

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) scanCards(node);
        });
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();

/* 1000 Marcas — rótulos PT-BR para filtros dinâmicos de cor da vitrine. */
(() => {
  if (window.__MM_PTBR_FILTER_COLORS_LOADED__) return;
  window.__MM_PTBR_FILTER_COLORS_LOADED__ = true;

  const locale = (document.documentElement.lang || '').toLowerCase();
  if (!(locale === 'pt-br' || locale === 'pt_br' || locale.startsWith('pt-br'))) return;

  const pageClassList = document.body?.classList;
  const hasFilterSurface = pageClassList?.contains('theme-template-collection') || pageClassList?.contains('theme-template-search');
  if (!hasFilterSurface) return;

  const colorTranslations = new Map([
    ['black', 'Preto'],
    ['white', 'Branco'],
    ['silver', 'Prata'],
    ['gray', 'Cinza'],
    ['grey', 'Cinza'],
    ['blue', 'Azul'],
    ['navy', 'Azul-marinho'],
    ['navy blue', 'Azul-marinho'],
    ['red', 'Vermelho'],
    ['green', 'Verde'],
    ['yellow', 'Amarelo'],
    ['orange', 'Laranja'],
    ['purple', 'Roxo'],
    ['pink', 'Rosa'],
    ['brown', 'Marrom'],
    ['beige', 'Bege'],
    ['gold', 'Dourado'],
    ['clear', 'Transparente'],
    ['transparent', 'Transparente'],
    ['multicolor', 'Multicolorido'],
    ['multicolour', 'Multicolorido'],
    ['teal', 'Verde-petróleo'],
    ['turquoise', 'Turquesa'],
    ['burgundy', 'Bordô'],
    ['maroon', 'Bordô'],
    ['olive', 'Oliva'],
    ['lime', 'Verde-limão'],
    ['coral', 'Coral'],
    ['khaki', 'Cáqui'],
    ['ivory', 'Marfim'],
    ['cream', 'Creme'],
    ['bronze', 'Bronze'],
    ['copper', 'Cobre'],
    ['light blue', 'Azul-claro'],
    ['dark blue', 'Azul-escuro'],
    ['light gray', 'Cinza-claro'],
    ['light grey', 'Cinza-claro'],
    ['dark gray', 'Cinza-escuro'],
    ['dark grey', 'Cinza-escuro'],
    ['light green', 'Verde-claro'],
    ['dark green', 'Verde-escuro'],
    ['smoke', 'Fumê'],
    ['amber', 'Âmbar'],
    ['assorted', 'Sortido']
  ]);

  const targetSelector = [
    '.active-filter-control',
    '.filter-label',
    '.swatch-option__label-text',
    '.js-filter ul li label > span.p-break-words'
  ].join(', ');

  const translateColorLabel = (value) => {
    if (typeof value !== 'string' || !value.trim()) return value;

    const leading = value.match(/^\s*/)?.[0] || '';
    const trailing = value.match(/\s*$/)?.[0] || '';
    const core = value.trim();
    const countMatch = core.match(/^(.*?)(\s*\(\d+\))$/);
    const label = (countMatch ? countMatch[1] : core).trim();
    const suffix = countMatch ? countMatch[2] : '';

    const direct = colorTranslations.get(label.toLowerCase());
    if (direct) return `${leading}${direct}${suffix}${trailing}`;

    let changed = false;
    const pieces = label.split(/(\s*(?:\/|\+|&|,)\s*)/);
    const translatedPieces = pieces.map((piece) => {
      if (/^(\s*(?:\/|\+|&|,)\s*)$/.test(piece)) return piece;
      const translated = colorTranslations.get(piece.trim().toLowerCase());
      if (!translated) return piece;
      changed = true;
      const pieceLeading = piece.match(/^\s*/)?.[0] || '';
      const pieceTrailing = piece.match(/\s*$/)?.[0] || '';
      return `${pieceLeading}${translated}${pieceTrailing}`;
    });

    if (!changed) return value;
    return `${leading}${translatedPieces.join('')}${suffix}${trailing}`;
  };

  const translateElement = (element) => {
    if (!element || element.nodeType !== Node.ELEMENT_NODE) return;

    const candidates = [];
    if (element.matches?.(targetSelector)) candidates.push(element);
    element.querySelectorAll?.(targetSelector).forEach((item) => candidates.push(item));

    candidates.forEach((item) => {
      const current = item.textContent;
      const translated = translateColorLabel(current);
      if (translated !== current) item.textContent = translated;
    });
  };

  const start = () => {
    translateElement(document.documentElement);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) translateElement(node);
          if (node.nodeType === Node.TEXT_NODE && node.parentElement?.matches?.(targetSelector)) {
            const current = node.parentElement.textContent;
            const translated = translateColorLabel(current);
            if (translated !== current) node.parentElement.textContent = translated;
          }
        });
      });
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();

/* 1000 Marcas — garante o JS do estimador de frete do Cart Drawer após re-render AJAX. */
(() => {
  if (window.__MM_CART_DRAWER_SHIPPING_LOADER__) return;
  window.__MM_CART_DRAWER_SHIPPING_LOADER__ = true;

  const setup = () => {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer) return;

    const source = drawer.dataset.estimateShippingScript;
    const shippingDrawerSrc = source?.replace('estimate-shipping-rate.js', 'estimate-shipping-rate-drawer.js');
    if (!shippingDrawerSrc) return;

    let loading = false;

    const load = () => {
      if (customElements.get('mm-cart-shipping-rate') || loading) return;

      loading = true;
      const script = document.createElement('script');
      script.src = shippingDrawerSrc;
      script.onload = () => { loading = false; };
      script.onerror = () => { loading = false; };
      document.head.appendChild(script);
    };

    const ensure = () => {
      if (drawer.querySelector('mm-cart-shipping-rate')) load();
    };

    ensure();

    const observer = new MutationObserver(ensure);
    observer.observe(drawer, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup, { once: true });
  } else {
    setup();
  }
})();
